import React from 'react';
import CustomDropdown, { DropdownOption } from './custom-dropdown.component';


interface CurrencyInputProps {
  value?: number | string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  currency: string;
  onCurrencyChange: (cur: string) => void;
  currencies: string[];
  placeholder?: string;
  name?: string;
  type?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  currency,
  onCurrencyChange,
  currencies,
  placeholder,
  name,
  type = 'number',
  className = '',
  style = {},
}) => {
  // Convert currencies array to dropdown options
  const currencyOptions: DropdownOption[] = currencies.map(cur => ({
    value: cur,
    label: cur,
  }));

  return (
    <div className={`position-relative ${className}`} style={style}>
      <div className="d-flex border rounded pl-3 align-items-center">
        <input
          type={type}
          className="form-control border-0 p-0 shadow-none py-2"
          placeholder={placeholder}
          name={name}
          value={value || ''}
          onChange={onChange}
          style={{ flex: 1 }}
        />
        <div className="vr mx-2" />
        
        <CustomDropdown
          options={currencyOptions}
          value={currency}
          onSelect={onCurrencyChange}
          fullWidth={true}
          parentRelativeWidth={true}
          className="currency-dropdown"
        />
      </div>
    </div>
  );
};

export default CurrencyInput;
